import { Check } from 'lucide-react';
import styled from 'styled-components';

export const Overlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
	overflow-y: auto;
	padding: 20px;

	/* Mejorar posicionamiento en iframes */
	@media (max-height: 600px) {
		align-items: flex-start;
		padding-top: 10px;
	}

	/* Para pantallas muy pequeñas */
	@media (max-width: 480px) {
		padding: 10px;
	}

	/* Estilos específicos para iframes */
	&.iframe-modal {
		align-items: flex-start;
		padding-top: 20px;
		padding-bottom: 20px;

		@media (max-height: 500px) {
			padding-top: 10px;
			padding-bottom: 10px;
		}
	}
`;

export const ModalContainer = styled.div<{ wide?: boolean }>`
	background: white;
	border-radius: 16px;
	padding: 32px;
	width: 90%;
	max-width: ${(props) => (props.wide ? '900px' : '400px')};
	max-height: 90vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 24px;
	overflow-y: auto;
	margin: auto;

	/* Mejorar posicionamiento en iframes y pantallas pequeñas */
	@media (max-height: 600px) {
		max-height: 95vh;
		margin: 0 auto;
	}

	/* Para pantallas muy pequeñas */
	@media (max-width: 480px) {
		padding: 20px;
		width: 95%;
		max-height: 98vh;
	}

	/* Estilos específicos para iframes */
	.iframe-modal & {
		max-height: 85vh;
		margin: 0 auto;

		@media (max-height: 500px) {
			max-height: 90vh;
		}
	}
`;

export const CheckIcon = styled.div`
	width: 48px;
	height: 48px;
	background: #e86339;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
`;

export const StyledCheck = styled(Check)`
	width: 24px;
	height: 24px;
	stroke-width: 3;
`;

export const Title = styled.h2`
	font-size: 20px;
	color: #333333;
	text-align: center;
	margin: 0;
`;

export const ButtonGroup = styled.div`
	display: flex;
	gap: 16px;
	width: 100%;
	margin-top: 8px;

	button {
		padding: 12px;
		white-space: nowrap;
	}
`;
